import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
        dark: false,
        options: { customProperties: true },
        themes: {
            name: "StefCastro 1",
            light: {
                primary: "#495464",
                lighten: "#f4f4f2",
                accent: "#bbbfca",
                secondary: "#e8e8e8",
                success: "#33cc66",
                info: "#e8e8e8",
                warning: "#ff9800",//"#ffff00",
                error: "#cc3333",
                accent40: "#bbbfca"
            }
        },
    },
});

export default vuetify